import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable()
export class FileSaverService {

    public saveBase64ToFile(fileName: string, documentContent: string, contentType: string) {
        var byteCharacters = atob(documentContent);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        this.saveByteArrayToFile(fileName, byteArray, contentType);
    }

    public saveByteArrayToFile(filename: string, byteArray: Uint8Array, contentType: string) {
        var blob = new Blob([byteArray], { type: contentType });
        FileSaver.saveAs(blob, filename);
    }

    public saveBlobToFile(blob: Blob, filename: string) {
        FileSaver.saveAs(blob, filename);
    }
}
